import sensors from "sa-sdk-javascript";
import cookie from "cookie";
import ua from 'ua'
import logger from 'logger'

let config = {};
let commonProp = {
  platform_type: "Web",
  city_id: cookie.get("cityId") || 1,
  channel: cookie.get("channel") || ""
};

/**
 * 修正 在预发打包就会叫prerelease
 */
if (ua.isBeta()) {
  config = {
    server_url: "https://shencedata.piaoniu.com/sa?project=default",
    show_log: true
  };
  commonProp.beta_flag = "beta";
} else {
  config = {
    server_url: "https://shencedata.piaoniu.com/sa?project=default",
    show_log: false
  };
  commonProp.beta_flag = "";
}

sensors.init(config);
sensors.registerPage(commonProp);

let SensorData = sensors;

// 移除神策打点，留空方法
// module.exports = SensorData
module.exports = {
  track(action, v){
    pnlogger.sendEvent(action, JSON.stringify(v))
  },
  login(){},
  logout(){}
};



// WEBPACK FOOTER //
// ./src/mods/sensors.js